import React from 'react';
import StakingPool from './StakingPool';
import { stakingTypes } from 'src/utils/smartContract';
import useMinimumStaking from 'src/hooks/useMinimumStaking';

export default function StakingPoolsContainer({ account, currentEpoch, tokenBalance = 0, updateTotalStakeAmount }) {
    const { minimumStaking } = useMinimumStaking();

    return (
        <>
            {Object.values(stakingTypes).map((stakingDiscriminant) => (
                <StakingPool
                    key={stakingDiscriminant}
                    currentEpoch={currentEpoch}
                    account={account}
                    discriminant={stakingDiscriminant}
                    tadaTokenBalance={tokenBalance || 0}
                    minimumStaking={minimumStaking}
                    updateTotalStakeAmount={updateTotalStakeAmount}
                />
            ))}
        </>
    );
}
